// removed by extract-text-webpack-plugin
module.exports = {"ordersWrap":"qempo_Orders_ordersWrap-3qY-inz"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/orders/components/Orders.scss
// module id = 1805
// module chunks = 0